import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-800 to-blue-900 text-white">
      {/* Floating Calculator Button */}
      <div className="relative">
        <div className="absolute -top-12 right-8 lg:right-16">
          <div className="w-24 h-24 bg-gradient-to-br from-orange-500 to-blue-600 rounded-full flex items-center justify-center shadow-2xl border-4 border-white cursor-pointer hover:scale-105 transition-transform">
            <div className="text-center">
              <div className="text-white text-xs font-bold leading-tight">
                FESTPREIS<br/>RECHNER
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Logo and Info */}
        <div className="mb-8">
          <div className="flex items-center mb-4">
            <span className="text-3xl font-bold">
              <span className="text-white">maler</span>
              <span className="text-orange-400">bw</span>
              <span className="text-gray-300">festpreis</span>
              <span className="text-lg text-orange-400">.de</span>
            </span>
            <div className="ml-3 w-8 h-8 bg-gradient-to-br from-blue-400 via-orange-400 to-green-400 rounded transform -rotate-12 flex items-center justify-center">
              <div className="w-4 h-4 bg-white rounded-sm opacity-90"></div>
            </div>
          </div>
          <p className="text-gray-300 max-w-2xl">
            Ihr Partner für professionelle Malerarbeiten in Baden-Württemberg. 
            Mit modernster Airless-Technologie und transparenten Festpreisen.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h4 className="text-lg font-bold mb-4 text-orange-400">Unsere Leistungen</h4>
            <ul className="space-y-2 text-gray-300">
              <li>• Innenanstriche mit Airless</li>
              <li>• Außenanstriche</li>
              <li>• Gewerbe & Büroräume</li>
              <li>• Renovierung & Sanierung</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4 text-orange-400">Service-Gebiete</h4>
            <ul className="space-y-2 text-gray-300">
              <li>• Stuttgart & Umgebung</li>
              <li>• Karlsruhe Region</li>
              <li>• Mannheim & Heidelberg</li>
              <li>• Ganz Baden-Württemberg</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-bold mb-4 text-orange-400">Vorteile</h4>
            <ul className="space-y-2 text-gray-300">
              <li>• Festpreis-Garantie</li>
              <li>• Airless-Profi-Technik</li>
              <li>• Professionelle Ausführung</li>
              <li>• Schnelle Ausführung</li>
            </ul>
          </div>
        </div>

        {/* Footer Links */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-wrap justify-center space-x-6 text-sm mb-4">
            <Link to="/impressum" className="text-gray-300 hover:text-white transition-colors">
              IMPRESSUM
            </Link>
            <span className="text-gray-500">|</span>
            <Link to="/datenschutz" className="text-gray-300 hover:text-white transition-colors">
              DATENSCHUTZ
            </Link>
            <span className="text-gray-500">|</span>
            <Link to="/agb" className="text-gray-300 hover:text-white transition-colors">
              AGB
            </Link>
            <span className="text-gray-500">|</span>
            <a href="#kontakt" className="text-gray-300 hover:text-white transition-colors">
              KONTAKT
            </a>
            <span className="text-gray-500">|</span>
            <a href="#cookie-einstellungen" className="text-gray-300 hover:text-white transition-colors">
              COOKIE-EINSTELLUNGEN
            </a>
          </div>
          
          <div className="text-center text-sm text-gray-400">
            © 2025 • malerbwfestpreis.de • Professionelle Malerarbeiten in Baden-Württemberg
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;